import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer';

import styles from '../../CheckoutCart.module.scss';

import { Button, ButtonTheme, ButtonVariant } from '@base-components/Button';
import { Column } from '@components/Column/Column';
import { RichText } from '@components/RichText/RichText';
import { useRedirect } from '@hooks/useRedirect';
import { Paths } from '@utils/paths/paths';

interface EmptyCartProps {
  headerText: string;
  subHeaderEmptyCartText: string;
  emptyCartText: StoryblokRichtext;
  continueShoppingText: string;
}

export const EmptyCart = ({
  headerText,
  subHeaderEmptyCartText,
  emptyCartText,
  continueShoppingText,
}: EmptyCartProps) => {
  const redirect = useRedirect();
  return (
    <div className={styles.cart}>
      <div className={styles.cartTopSection}>
        <div className={styles.cartHeader}>
          <h2>{headerText}</h2>
        </div>
        <div className={styles.cartSubHeader}>{subHeaderEmptyCartText}</div>
      </div>
      <Column
        items={[
          <div className={styles.emptyCartContent}>
            <RichText document={emptyCartText} />
            <Button
              as="button"
              onClick={() => redirect({ pageId: Paths.ProductsOverview })}
              variant={ButtonVariant.Basic}
              isFullWidth
              theme={ButtonTheme.Primary}
              dataAttribute={{ 'data-test-id': 'continue-shopping' }}
            >
              {continueShoppingText}
            </Button>
          </div>,
        ]}
        noOfColumns={1}
        mobileBehavior={'stacked'}
        outerMargin={false}
        stickyColumn={false}
        stickyOnMobile={false}
        invert={false}
      />
    </div>
  );
};
